import { render, staticRenderFns } from "./job-activity-badges.vue?vue&type=template&id=657c7432&scoped=true&"
import script from "./job-activity-badges.vue?vue&type=script&lang=js&"
export * from "./job-activity-badges.vue?vue&type=script&lang=js&"
import style0 from "./job-activity-badges.vue?vue&type=style&index=0&id=657c7432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657c7432",
  null
  
)

export default component.exports